import { fixedDateRange, formatDate, formatDay } from './dateUtils'

export default (elementValue, effectValue, format, colData) => {
  const { operator, value, col_type, field_type, date_operator_type, dynamic_date, daysValue, range_date, effect_options } = format
  let isEffect = false
  let text = elementValue
  const { col } = effect_options || {}
  if (col > -1 && colData && (format.dataset_field_id !== colData.field_id || format.col_type !== colData.col_type)) {
    text = effectValue
  }
  if (col_type === 'dim') {
    //值符合标准
    if (field_type === '日期') {
      const currentDate = (text && formatDate(text)) || []
      //日期类型
      let rangeDate = []
      if (date_operator_type === 'static') {
        rangeDate = range_date.map((d, index) => formatDay(d, index > 0))
      } else if (date_operator_type === 'dynamic' && !dynamic_date) {
        isEffect = true
      } else if (date_operator_type === 'dynamic') {
        rangeDate = fixedDateRange(dynamic_date, daysValue)
      } else if (date_operator_type === 'value') {
        switch (operator) {
          case 'is null':
            if (text === null) isEffect = true
            break
          case 'is not null':
            if (text !== null) isEffect = true
            break
          default:
            break
        }
      }
      if (rangeDate.length > 0 && currentDate.length > 0 && currentDate[0] >= rangeDate[0] && currentDate[1] <= rangeDate[1]) {
        isEffect = true
      }
    } else {
      switch (operator) {
        case '=':
        case 'in':
          if (text === '') {
            if (value.indexOf('(空)') > -1) isEffect = true
          } else if ((text || text === 0) && value.indexOf(text.toString()) > -1) isEffect = true
          break
        case '!=':
        case 'not in':
          if (text === '') {
            if (value.indexOf('(空)') === -1) isEffect = true
          } else if ((text || text === 0) && value.indexOf(text.toString()) === -1) isEffect = true
          break
        case 'is null':
          if (text === null) isEffect = true
          break
        case 'is not null':
          if (text !== null) isEffect = true
          break
        default:
          break
      }
    }
  } else {
    // 值符合标准
    switch (operator) {
      case '=':
        if (value[0] && (text || text === 0 || text === '') && value[0] === text.toString()) isEffect = true
        break
      case '!=':
        if (!(value[0] && (text || text === 0 || text === '') && value[0] === text.toString())) isEffect = true
        break
      case '>':
        if ((text || text === 0) &&  text > value[0]) isEffect = true
        break
      case '>=':
        if ((text || text === 0) && text >= value[0]) isEffect = true
        break
      case '<':
        if ((text || text === 0) && text < value[0]) isEffect = true
        break
      case '<=':
        if ((text || text === 0) && text <= value[0]) isEffect = true
        break
      case 'between':
        if ((text || text === 0) && text >= value[0] && text <= value[1]) isEffect = true
        break
      case 'is null':
        if (text === null) isEffect = true
        break
      case 'is not null':
        if (text !== null) isEffect = true
        break
      default:
        break
    }
  }
  return isEffect
}
